var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DiscordTechDesign',{attrs:{"variant":"classic"}})
}
var staticRenderFns = []

export { render, staticRenderFns }